import { calculateLineTotal, calculateLinesTotalExclVat, calculateLinesTotalVat } from '../../../domain/invoice-totals';

export interface ILine {
  amount: number;
  unitPrice: number;
  vatRatePercentage: number;
}

export { calculateLineTotal, calculateLinesTotalExclVat, calculateLinesTotalVat };

// €/km is what the customer pays per km of their ride: empty km are our cost, not theirs.
export function calculateEuroPerKm(amountInCents: number, distanceKm: number): number | null {
  if (distanceKm <= 0 || amountInCents <= 0) {
    return null;
  }

  return Math.round(amountInCents / distanceKm);
}

export function calculateProfitPercentage(purchaseTotal: number, saleTotal: number): number {
  if (purchaseTotal <= 0) {
    if (saleTotal <= 0) {
      return 0;
    } else {
      return 10000;
    }
  }

  const profit = saleTotal - purchaseTotal;
  return (profit / saleTotal) * 10000;
}
